import * as yup from 'yup'

export const professionalDataSchema = yup.object({
  previousCompany: yup.string().nullable(),
  currentCompany: yup.string().nullable(),
  position: yup.string().nullable(),
  sector: yup.string().nullable(),
  subsector: yup.string().nullable(),
  area: yup.string().nullable(),
  value: yup.string().nullable(),
  currency: yup.string().nullable(),
  smallGroup: yup.string().nullable(),
  blind: yup.string().nullable(),
  proactive: yup.string().nullable(),
  bio: yup.string().nullable(),
  observations: yup.string().nullable(),
})
